import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  InsertOrgContractAnalysisDocument,
  type InsertOrgContractAnalysisMutationVariables,
} from '@/graphql/generated/graphql';

export type OrgContractAnalysisInsertInput = InsertOrgContractAnalysisMutationVariables;

export const useInsertOrgContractAnalysis = () => {
  const mutation = useMutation({
    mutationKey: ['insert-org-contract-analysis'],
    mutationFn: (variables: InsertOrgContractAnalysisMutationVariables) =>
      graphqlClient.request(InsertOrgContractAnalysisDocument, variables),
  });

  return {
    ...mutation,
    insertOrgContractAnalysis: mutation.mutate,
    insertOrgContractAnalysisAsync: mutation.mutateAsync,
  };
};

export const INSERT_ORG_CONTRACT_ANALYSIS_MUTATION = InsertOrgContractAnalysisDocument;
